import {
  Component,
  inject,
  signal,
  computed
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';

import { FormsModule } from '@angular/forms';

import { Button } from '../button/button';
import { ConfirmationDialogButton } from '../../../core/enums/confirmationDialogButton.enum';

// ======================================================
// INTERFACE
// ======================================================

export interface ConfirmationDialogData {

  title: string;

  message: string;

  subText?: string;

  primaryButton: string;

  secondaryButton: string;

  extra?: {

    isBoldSubText?: boolean;

    type?: string;

    confirmText?: string;
  };
}

// ======================================================
// COMPONENT
// ======================================================
@Component({
  selector: 'isc-confirmation-dialog',
    imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    Button
  ],
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss',
})
export class ConfirmationDialog {

  // ====================================================
  // INJECT
  // ====================================================

  readonly dialogRef =
    inject(
      MatDialogRef<ConfirmationDialog>
    );

  readonly data =
    inject<ConfirmationDialogData>(
      MAT_DIALOG_DATA
    );

  // ====================================================
  // SIGNALS
  // ====================================================

  readonly typedText =
    signal('');

  readonly confirmText =
    signal('delete');

  readonly disableButton =
    signal(false);

  // ====================================================
  // COMPUTED
  // ====================================================

  readonly hasInputValidation =
    computed(() =>
      !!this.data?.extra?.type
    );

  // ====================================================
  // CONSTRUCTOR
  // ====================================================

  constructor() {

    if (
      this.data?.extra?.type
    ) {

      this.disableButton.set(
        true
      );

      if (
        this.data?.extra?.confirmText
      ) {

        this.confirmText.set(
          this.data
            .extra
            .confirmText
            .trim()
        );
      }
    }
  }

  // ====================================================
  // PRIMARY
  // ====================================================

  onPrimaryClick():
    void {

    this.dialogRef.close(
      ConfirmationDialogButton
        .PRIMARY
    );
  }

  // ====================================================
  // SECONDARY
  // ====================================================

  onSecondaryClick():
    void {

    this.dialogRef.close(
      ConfirmationDialogButton
        .SECONDARY
    );
  }

  // ====================================================
  // CLOSE
  // ====================================================

  onClose():
    void {

    this.dialogRef.close();
  }

  // ====================================================
  // VALIDATE
  // ====================================================

  validateTypedText(
    value: string
  ): void {

    this.typedText.set(
      value
    );

    this.disableButton.set(
      value.trim() !==
      this.confirmText()
    );
  }
}